import React, { Component } from 'react';

import moment from 'moment';
import { array, arrayOf, bool, func, string } from 'prop-types';

import { DatePickerMode } from '@philips-emr/tws-components-api';
import { Expression } from '@philips-emr/tws-constants';
import { date } from '@philips-emr/tws-core/lib/component/prop-types';
import { msg } from '@philips-emr/tws-core/lib/services/message-service';
import { classNames, isFunction, isMobile } from '@philips-emr/tws-utils';

import { Button } from '../..';
import { DatePickerTimeSpan } from '../components';
import DatePickerContent from '../components/date-picker-content';
import { getDataGrid, getMonthGridInterval } from '../date-picker-util';

class DatePickerInterval extends Component {

  static propTypes = {
    applyExpression: string,
    clearExpression: string,
    date: date,
    externalControls: bool,
    loading: bool,
    onArrowClick: func,
    onCellClick: func,
    onClear: func,
    onClick: func,
    onToday: func,
    rangeEnabled: bool,
    ranges: array,
    showClear: bool,
    todayExpression: string,
    value: arrayOf(date),
  };

  static defaultProps = {
    applyExpression: Expression.APPLY,
    clearExpression: Expression.CLEAR,
    rangeEnabled: true,
    ranges: [],
    todayExpression: Expression.TODAY,
    value: [],
  };

  onClick = () => {
    const { value, onClick } = this.props;

    isFunction(onClick) && onClick({ value });
  };

  renderCalendar(type, date, grid, mode, enablePrev, enableNext) {
    const { onArrowClick, onCellClick, loading, rangeEnabled, ranges, value } = this.props;
    const [startIntervalDate, endIntervalDate] = value;

    const calendarClassNames = classNames({
      [`c-date-picker-interval__${type}`]: true,
      'c-date-picker': true,
      'c-date-picker--monthly': true,
    });

    return (
      <div className={calendarClassNames}>
        <DatePickerTimeSpan date={date} mode={mode} onArrowClick={onArrowClick} enablePrev={enablePrev} enableNext={enableNext} />
        <DatePickerContent
          data={grid}
          endDate={endIntervalDate}
          interval
          loading={loading}
          mode={mode}
          onClick={onCellClick}
          rangeEnabled={rangeEnabled}
          ranges={ranges}
          startDate={startIntervalDate}
        />
      </div>
    );
  }

  renderPrimaryCalendar(date, mode) {
    const { value } = this.props;
    const [startIntervalDate, endIntervalDate] = value;

    const grid = getDataGrid({
      date,
      endIntervalDate,
      events: [],
      isIntervalMode: true,
      mode,
      startIntervalDate,
    });

    return this.renderCalendar('primary', date, grid, mode, true, isMobile());
  }

  renderSecondaryCalendar(date, mode) {
    const { value } = this.props;
    const [startIntervalDate, endIntervalDate] = value;

    const nextMonthDate = moment(date).utc().add(1, 'month');
    const nextMonthGrid = getMonthGridInterval(nextMonthDate, [], startIntervalDate, endIntervalDate);

    return this.renderCalendar('secondary', nextMonthDate, nextMonthGrid, mode, false, true);
  }

  renderFooter() {
    const {
      applyExpression,
      clearExpression,
      externalControls,
      onClear,
      onToday,
      showClear,
      todayExpression,
    } = this.props;

    if (externalControls) {
      return null;
    }

    return (
      <div className="c-date-picker-interval__footer">
        <span className="c-date-picker-interval__action" onClick={onToday}>{msg(todayExpression)}</span>
        {showClear && <span className="c-date-picker-interval__action" onClick={onClear}>{msg(clearExpression)}</span>}

        <Button onClick={this.onClick} value={msg(applyExpression)} />
      </div>
    );
  }

  render() {
    const {
      date = moment.utc(),
    } = this.props;

    const mode = DatePickerMode.MONTHLY;

    return (
      <div className="c-date-picker-interval">
        <div className="c-date-picker-interval__calendar-wrapper">
          {this.renderPrimaryCalendar(date, mode)}

          {!isMobile() && this.renderSecondaryCalendar(date, mode)}
        </div>

        {this.renderFooter()}
      </div>
    );
  }
}

export default DatePickerInterval;
